import axios from 'axios';

export const getSupplierSuggestion = ({ searchStr }) => {
    return new Promise((resolve, reject) => {
		axios.get("/marketplace/static/php/web/common_api.php?action=company_name_autosuggest&term="+searchStr).then(res => {
            if(res.data){
                resolve(res.data.results || []);
            }
        });
	});
};
export const getSupplierDetails = ({ docId, cb }) => {
    axios.get("/marketplace/static/php/web/service_api.php?action=companyDetails&docid="+docId).then(res => {
        if(res.data){
            cb(res.data.results);
        }
    });
};
export const getStateList = () => {
    return new Promise((resolve, reject) => {
		axios.get("/marketplace/geolocation/state/getAllState.service").then(res => {
            if(res.data){
                var stateArr = [];
                res.data.map((cur) => {
                    stateArr.push({
                        label: cur.name,
                        key: cur.name
                    })
                })
                resolve(stateArr);
            }
        });
	});
};
export const getCityState = (pin) => {
    return new Promise((resolve, reject) => {
		axios.get("/marketplace/gis/getDetailByPincode.service?priority=1&pincode="+pin).then(res => {
            if(res.data.result){
                resolve(res.data.result[0]);
            }
        });
	});
};
export const getFormattedData = (data) => {
    const { businessDetails, taxDetails, miscData, contactDetails, billingAddress } = data;
    contactDetails.map((cur, index) => {
        cur.mobileNumber.pop();
        cur.landlineNumber.pop();
        cur.email.pop();
        cur.defaultContactPerson = !index;
    });
    billingAddress.map((cur, index) => {
        cur.defaultAddress = !index;
        if(!cur.latitude)
            delete cur.latitude;
        if(!cur.longitude)
            delete cur.longitude;
    });
    var formattedData = {
        ...businessDetails,
        ...taxDetails,
        ...miscData,
        contactPerson: contactDetails,
        vendorAddress: billingAddress,
        supplierId: data.supplierId
    };
    console.log(formattedData);
    return formattedData;
};
export const formatSupplierData = ({vendorName, supplierId, vendorId}) => {
    return new Promise((resolve, reject) => {
		axios.get('/marketplace/purchaseorder/ajax/service/getAllVendor.service?supplierId='+supplierId+'&showJdResults=false&currentPage=1&searchKey='+vendorName+'&pageSize=20&module=manageProduct').then(res => {
            if(res.data.data){
                var suppliers = res.data.data;
                for(var index=0; index<suppliers.length; index++){
                    if(vendorId == suppliers[index].vendorMongoId){
                        resolve(suppliers[index]);
                        break;
                    }
                }
            }
        });
	});
};
export const createSupplier = ({supplierData, createCb}) => {
    var dataToSend = getFormattedData(supplierData);
    var postData = {
        data: JSON.stringify(dataToSend)
    };
    axios
        .post("/marketplace/vendor/ajax/service/createVendor.service", dataToSend)
        .then((res) => {
            formatSupplierData({
                vendorName: dataToSend.companyName,
                supplierId: dataToSend.supplierId,
                vendorId: res.data.vendorId
            }).then(supplier => {
                createCb(supplier);
            })
        }
    )
};
export const getBusinessDetailsObj = () => {
    return ({
        companyName: '',
        nickName: '',
        website: ''
    })
};
export const getContactPersonObj = ( obj={}, fromService ) => {
    var contactObj = {};
    if(fromService){
        contactObj = {
            name: (obj.firstName +' '+ obj.lastName || ''),
            mobileNumber: obj.mobileList ? obj.mobileList+',' : '',
            landlineNumber: obj.landlineList ? obj.landlineList+',' : '',
            email: obj.emailList ? obj.emailList+',' : ''
        };
        // For an extra field
        contactObj.mobileNumber = contactObj.mobileNumber.split(',');
        contactObj.landlineNumber = contactObj.landlineNumber.split(',');
        contactObj.email = contactObj.email.split(',');
    }else{
        contactObj = {
            name: '',
            mobileNumber: [''],
            landlineNumber: [''],
            email: ['']
        };
    }
    return contactObj;
};
export const getBillingAddressObj = ( obj={}, cb=()=>{} ) => {
    var addressObj = {
        pincode: obj.pincode || '',
        addressline1: obj.addressline1 || obj.address || '',
        addressline2: obj.addressline2 || obj.landmark || '',
        area: obj.area || '',
        city: obj.city || '',
        state: obj.state || '',
        country: obj.country || '',
        latitude: obj.latitude || '',
        longitude: obj.longitude || '',
    };
    if(obj.pincode){
        getCityState(obj.pincode).then((res) => {
            addressObj.city = addressObj.city || res.city;
            addressObj.state = res.state;
            addressObj.country = res.country;
            cb(addressObj);
        })
    }else{
        return addressObj;
    }
};
export const getTaxObj = ( obj={} ) => {
    return ({
        panNumber: obj.panNumber || '',
        gstinNumber: obj.gstinNumber || ''
    })
};
export const getMiscObj = ( obj={} ) => {
    return ({
        note: obj.note || '',
        vendorLogo: obj.vendorLogo || obj.logo || ''
    })
};
export const Regex = {
    website: /^((https?):\/\/)?(www.)?([a-zA-Z0-9]{2,})+\.[a-zA-Z0-9]+(\.?[a-zA-Z0-9]?)+\/?([a-zA-Z0-9#]+\/?)*$/,
    gstIn: /^[a-zA-Z0-9]{15}$/
}